import { render } from "./UploadFormPopup.vue?vue&type=template&id=2ad1c90e&ts=true"
import script from "./UploadFormPopup.vue?vue&type=script&lang=ts"
export * from "./UploadFormPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__